export const STATUS_TICKET_IN_PROGRESS = 'In progress'
export const STATUS_TICKET_TO_DO = 'To Do'
export const STATUS_TICKET_DONE = 'Done'

export const STATUS_COLOR_TICKET_INFO = 'info'
export const STATUS_COLOR_TICKET_SUCCESS = 'success'
export const STATUS_COLOR_TICKET_WARNING = 'warning'
export const STATUS_COLOR_TICKET_DANGER = 'danger'
export const STATUS_COLOR_TICKET_SECONDARY = 'secondary'
